import React, { useState } from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Table,
  Space,
  Skeleton,
  Result
} from 'antd'
import {
  SearchOutlined
} from '@ant-design/icons';
import DeletePopupButton from './components/DeletePopupButton';
import EditFormModal from './components/EditFormModal';
import AddFormModal from './components/AddFormModal';

import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'name',
    key: 'name',
  },
  // {
  //   title: 'รายละเอียด',
  //   dataIndex: 'description',
  //   key: 'description',
  // },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width:'80%',
    render: (_, record) => (
      <Space size="middle">
        <EditFormModal data={record} />
        <DeletePopupButton data={record} />
      </Space>
    ),

  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['/api/brand/'],
  })
  // console.log('data :', data);

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.name.includes(s))
    setFilterData(target);
  }

  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการแบรนด์สินค้า
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <AddFormModal />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="ค้นหา" prefix={<SearchOutlined />} onChange={onSearch} />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={filterData || data}
                scroll={{
                  x: 1200,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List